import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";

import { formatString } from "@/core/utils/helpers";
import {
  CreateDepartmentDto,
  UpdateDepartmentDto,
} from "../dtos/department.dtos";
import { DEPARTMENT_API_PATHS } from "../constants";

class DepartmentService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public getDepartments(
    organizationId: string,
    isActive?: boolean,
  ): Promise<ICoreResponse> {
    const basePath = formatString(
      DEPARTMENT_API_PATHS.GET_DEPARTMENTS,
      organizationId,
    );
    const url =
      typeof isActive === "boolean"
        ? `${basePath}?is_active=${isActive}`
        : basePath;
    return this.restClient.get(url);
  }

  public createDepartment(
    organizationId: string,
    body: CreateDepartmentDto,
  ): Promise<ICoreResponse> {
    return this.restClient.post(
      formatString(DEPARTMENT_API_PATHS.CREATE_DEPARTMENT, organizationId),
      body,
    );
  }

  public updateDepartment(
    organizationId: string,
    body: UpdateDepartmentDto,
  ): Promise<ICoreResponse> {
    return this.restClient.post(
      formatString(DEPARTMENT_API_PATHS.UPDATE_DEPARTMENT, organizationId),
      body,
    );
  }

  public patchDepartmentStatus(
    organizationId: string,
    departmentId: string,
    isActive: boolean,
  ): Promise<ICoreResponse> {
    return this.restClient.patch(
      formatString(
        DEPARTMENT_API_PATHS.PATCH_DEPARTMENT_STATUS,
        organizationId,
        departmentId,
      ),
      {
        is_active: isActive,
      },
    );
  }

  public deleteDepartment(
    organizationId: string,
    publicId: string,
  ): Promise<ICoreResponse> {
    return this.restClient.delete(
      formatString(
        DEPARTMENT_API_PATHS.DELETE_DEPARTMENT,
        organizationId,
        publicId,
      ),
      "",
    );
  }
}

export default DepartmentService;
